import { createFileRoute } from '@tanstack/react-router'

import HomePage from '@/features/dashboard/pages/home'

export const Route = createFileRoute('/_shell/')({ component: HomePage })
